import { render, staticRenderFns } from "./beginnerTipsDia.vue?vue&type=template&id=194ddf98&scoped=true&"
import script from "./beginnerTipsDia.vue?vue&type=script&lang=js&"
export * from "./beginnerTipsDia.vue?vue&type=script&lang=js&"
import style0 from "./beginnerTipsDia.vue?vue&type=style&index=0&id=194ddf98&lang=scss&scoped=scoped&"
import style1 from "./beginnerTipsDia.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ddf98",
  null
  
)

export default component.exports